import { render } from "./detail.vue?vue&type=template&id=a4cfec06"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=a4cfec06&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3b689470-9235-485d-ba5a-49630a920e29/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__